import { Api } from '../../../../shared/constants/api';

export class TenantRouteUtil {
  public static getTenantRoutePath(fullPath: string): string {
    if (fullPath.includes(`/${Api.organizations}/${Api.all}`)) {
      return `/${Api.admin}/${Api.organizations}/${Api.all}`;
    }

    return `/${Api.admin}/${Api.organizations}/${Api.my}`;
  }

  public static getAllTenantsRoutePathForTesting(): string[] {
    return [`/${Api.admin}/${Api.organizations}/${Api.my}`, `/${Api.admin}/${Api.organizations}/${Api.all}`];
  }
}
